import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    Button,
    Card,
    CardBody,
    Input,
    Label,
    ListGroup,
    ListGroupItem
} from "reactstrap";
import { createSelector } from "reselect";
import { clearSearchCategoriesFunc, getCategoriesFunc, searchCategoriesFunc } from "slices/thunks";
import "./categorySelector.scss";
import { clearCategoriesByNameAI, getBrandCategoryIdByThunk } from "live-slices/thunk";

let searchTimeout: any;


export const CategorySelectInput: React.FC<any> = ({ initialCategory, onCategorySelect }) => {
    const [inputCategory, setInputCategory] = useState("");
    const [selectedCategory, setSelectedCategory] = useState<any>();
    const [isCategorySelectorShown, setIsCategorySelectorShown] = useState<boolean>(false);
    const [abc, setAbc] = useState<string | null>(null);
    const dispatch = useDispatch<any>();
    const searchCategoriesData = createSelector(
        (state: any) => state.Category,
        (searchList) => searchList?.searchList ?? []
    );
    const [categoryListing, setCategoryListing] = useState<any[]>([]);
    const searchList = useSelector(searchCategoriesData);
    const selectCategoriesData = createSelector(
        (state: any) => state.Category,
        (categories) => categories?.categories ?? []
    );
    const dropdownRef = useRef<HTMLDivElement>(null);
    const categories = useSelector(selectCategoriesData);

    const searchCategoriesDataAI = createSelector(
        (state: any) => state.Category,
        (categoriesSearchAI) => categoriesSearchAI?.categoriesSearchAI ?? []
    );
    const categoriesSearchAI = useSelector(searchCategoriesDataAI); 

    useEffect(() => {
            dispatch(getCategoriesFunc(''));
        drawCategoryListing();
    }, [dispatch, categories]);

    useEffect(() => {
        drawCategoryListing();
        console.log("selectedCategory",selectedCategory)
        
    }, [selectedCategory])

    useEffect(() => {
        console.log("inputCategory",inputCategory)
        
    }, [inputCategory])

    useEffect(() => {
        if (initialCategory && Object.keys(initialCategory).length) {
            setInputCategory(initialCategory.path.join(' > '));
            setSelectedCategory(initialCategory);
        }
    }, [initialCategory])

    const handleCategorySelectForAI = (category: any) => {
        const idPathArray = category.idpath.split(",").map((x: any) => x.trim());
        let categoryMorph = {
            _id: idPathArray[idPathArray.length - 1].trim(),
            name: category.name,
            path:category.path.split(",").map((x: any) => x.trim()),
            idPath: idPathArray,
            leaf:true
        }
        console.log(categoryMorph)
        setSelectedCategory(categoryMorph);


            
            confirmCategory(categoryMorph._id,categoryMorph);
            dispatch(clearCategoriesByNameAI());
    }


    const handleCategoryInputChange = (e: any) => {
        clearTimeout(searchTimeout);
        const value = e.target.value;
        setInputCategory(value);
        searchTimeout = setTimeout(() => {

            console.log("Search Called ==>",value);
            if(value === "") {
                dispatch(clearSearchCategoriesFunc()); 
            }
            else{

                dispatch(searchCategoriesFunc(value));
            }
        }, 1500);
    };

    const onHandleCategory = (category: any) => {
        setSelectedCategory(category);
        dispatch(clearSearchCategoriesFunc());
        setIsCategorySelectorShown(true);
    };

    const getCategoriesAccordingToId = (id: string) => {
        return categories.filter((x: any) => x.parentId === id);
    }

    
    
    

    const selectCategory = (category: any) => {
        setSelectedCategory(category);
     
        if (category.parentId === "") {
            setAbc(category._id);
            console.log("Top-level category _id saved in abc:", category._id);
            sessionStorage.setItem("categoryid", category._id);
            dispatch(getBrandCategoryIdByThunk({ categoryId: category._id }));
        }
        if (!category.leaf) {
            dispatch(getCategoriesFunc(category._id));
        }
    }

    const drawCategoryListing = () => {
        let drawList = [];
        drawList.push({
            keyword: "",
            list: getCategoriesAccordingToId(''),
            filteredList: function () {
                return this.list.filter((item: any) => item.name.toLowerCase().includes(this.keyword.toLowerCase())
                );
            }
        });
        if (selectedCategory) {
            for (let id of selectedCategory.idPath) {
                if (selectedCategory.leaf && selectedCategory._id === id) {
                    continue;
                }
                drawList.push({
                    keyword: "",
                    list: getCategoriesAccordingToId(id),
                    filteredList: function () {
                        return this.list.filter((item: any) => item.name.toLowerCase().includes(this.keyword.toLowerCase())
                        );
                    }
                });
            }
        }
        setCategoryListing(drawList);
    }

    const confirmCategory = (id: string,category=selectedCategory) => {
        onCategorySelect(selectedCategory);
        dispatch(clearSearchCategoriesFunc());
        setIsCategorySelectorShown(false);
        dispatch(getBrandCategoryIdByThunk({ categoryId: category.idPath[0] }));
        if(category){

            setInputCategory(category.path.join(' > '));
        }
    }

    const updateFilterKeyword = (index: number, event: any) => {
        let list = [...categoryListing];
        list[index].keyword = event.target.value;
        setCategoryListing(list);
    }

    

    return (
        <div className="mb-3 mt-2 formContainer position-relative">
            <Label className="form-label" htmlFor="category-input">
                Category<sup className="text-danger fs-6">*</sup> 
            </Label>
            <Input
                type="text"
                className="form-control"
                placeholder="Please select category or search with keyword"
                name="categories"
                required
                autoComplete="off"
                value={inputCategory}
                onChange={handleCategoryInputChange}
                onClick={() => setIsCategorySelectorShown(true)}
                data-testing-id="categoryInput_addProducts"
            />
            { searchList.length > 0 && (
                <div
                    className="dropdown-menu show"
                    style={{ 
                        width: "100%", maxHeight: "200px", overflowY: "auto" }}
                >
                    {searchList.map((category: any, index: any) => (
                        <div
                            key={"categorySelectorSearch" + category._id}
                            className="dropdown-item"
                            style={{ cursor: "pointer" }}
                            onClick={() => onHandleCategory(category)}
                        >
                            {category.path.join(" > ")}
                        </div>
                    ))}
                </div>
            )}

            {categoriesSearchAI.length > 0 && (
                <div>
                    <div className="selector">
                        <h1>Category Suggestions</h1>
                        {categoriesSearchAI.map((category: any, index: any) => (
                            <div className="d-flex mb-2">

                                <input
                                    type="radio"
                                    name="category"
                                    value={category.path}
                                    // checked={selectedCategory === category.path}
                                    onChange={() => handleCategorySelectForAI(category)}
                                />
                                <p className="m-0">{category.path.replaceAll(",", ">")} </p>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {
                isCategorySelectorShown &&
                <Card>
                    <CardBody >
                        <div className="categorySelector">
                            {categoryListing.map((category, index1) => {
                                return (
                                    <div className="categoryPath" key={category._id}>
                                        <div className="search-box" data-testing-Id={"category_addProducts" +index1}>
                                            <Input
                                                type="text"
                                                value={category.keyword}
                                                onChange={(e) => updateFilterKeyword(index1, e)}
                                                className="form-control search"
                                                placeholder="Search"
                                                
                                            />
                                            <i className="ri-search-line search-icon"></i>
                                        </div>
                                        <ListGroup>
                                            {
                                                category.filteredList().map((category: any , index : any) => {
                                                    return <ListGroupItem data-testing-Id={"categoryList" + index1+"_addProducts" + index } className={selectedCategory && (selectedCategory._id === category._id || selectedCategory.idPath.includes(category._id)) ? 'active' : ''} onClick={() => selectCategory(category)} key={category._id}>{category.name}
                                                        {!category.leaf && <i className="mdi mdi-chevron-right"></i>}
                                                    </ListGroupItem>;
                                                })
                                            }
                                        </ListGroup>
                                    </div>
                                );
                            })}
                        </div>
                        <div className="d-flex align-items-center mt-2">
                            {selectedCategory && <p>Current Selection: {selectedCategory.path.join(' > ')} </p>}
                        </div>
                        <div className="d-flex align-items-center justify-content-end" style={{ gap: 10 }}>
                            <Button outline color="dark" data-testing-Id="categoryCancel_addProducts" onClick={() => setIsCategorySelectorShown(false)}>Cancel</Button>
                            <Button color="secondary" data-testing-Id="categoryConfirm_addProducts" onClick={() => confirmCategory(selectedCategory._id)}>Confirm</Button>
                        </div>
                    </CardBody>
                </Card>
            }
        </div>

    );
}
